import Alert from './Alert';

function ucfirst(s = '') {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

function currentPageTitle() {
  try {
    const path = window.location?.pathname || '';
    const parts = path.split('/').filter(Boolean);
    const seg = parts.length >= 2 && parts[0] === 'painel' ? parts[1] : parts[parts.length - 1];
    return ucfirst((seg || '').replace(/-/g, ' '));
  } catch {
    return '';
  }
}

/**
 * Uso:
 *   return <PermissionDeniedAlert />;
 *   // opcional: <PermissionDeniedAlert message="Acesso negado." />
 */
export default function PermissionDeniedAlert({ message }) {
  const page = currentPageTitle();
  const text = message || 'Acesso não permitido.';
  return (
    <Alert variant="danger" title={text}>
      {page ? `Você não tem permissão para acessar ${page}.` : 'Você não tem permissão para acessar este recurso.'}
    </Alert>
  );
}
